// Shared expiry maths for document rows.
//
// The backend sends `expiry_in_days` (integer; negative once expired, null
// when the document has no expiry date) and `is_expired`. Everything visual
// derives from here so the table, the grid cards and the detail page never
// disagree about what "expires today" means.

export const EXPIRING_SOON_DAYS = 7;

export const EXPIRY_STATE = {
  NONE: "none", // no expiry date on the document
  EXPIRED: "expired",
  TODAY: "today",
  SOON: "soon", // 1..EXPIRING_SOON_DAYS days left
  OK: "ok",
};

const pluralDays = (n) => `${n} ${n === 1 ? "day" : "days"}`;

export const getExpiryMeta = (document) => {
  const raw = document?.expiry_in_days;
  const days = raw === null || raw === undefined || raw === "" ? NaN : Number(raw);

  if (Number.isNaN(days)) {
    return { state: EXPIRY_STATE.NONE, days: null, label: "No expiry", rowClass: "" };
  }
  if (days < 0) {
    return {
      state: EXPIRY_STATE.EXPIRED,
      days,
      label: `Expired ${pluralDays(-days)} ago`,
      rowClass: "doc-row-expired",
    };
  }
  if (days === 0) {
    return { state: EXPIRY_STATE.TODAY, days: 0, label: "Today", rowClass: "doc-row-today" };
  }
  if (days <= EXPIRING_SOON_DAYS) {
    return { state: EXPIRY_STATE.SOON, days, label: pluralDays(days), rowClass: "doc-row-soon" };
  }
  return { state: EXPIRY_STATE.OK, days, label: pluralDays(days), rowClass: "" };
};
